import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: '/publication',
    name: 'publication',
    component: () => import("../views/PublicationView.vue"),
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import("../views/DemoView.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
